// Actions
import {
  AUTH_LOG_USER_IN,
  AUTH_LOG_USER_OUT,
  AUTH_MERGE_USER_DETAILS,
  AUTH_SET_USER_DETAILS,
  AUTH_SET_USER,
} from '../actionTypes';

/**
 * Initial state
 * @type {{
 *    isLogged: boolean If the user is logged on the application,
 *    user: object|null The user object
 * }}
 */
export const initialState = {
  isLogged: false,
  user: {},
  userDetails: {},
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    /**
     * Logs the user on the application
     * payload: {token: string, user: object}
     */
    case AUTH_LOG_USER_IN:
      return {
        ...state,
        isLogged: true,
        user: action.payload.user,
      };

    /**
     * Sets the user details
     * payload: {userDetails: object}
     */
    case AUTH_SET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload.userDetails,
      };

    /**
     * Merges fields into the user details, so callers never have to spread a
     * possibly outdated copy of the object
     * payload: {userDetails: object}
     */
    case AUTH_MERGE_USER_DETAILS:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          ...action.payload.userDetails,
        },
      };

      /**
       * Sets the user details
       * payload: {user: object}
       */
    case AUTH_SET_USER:
      return {
        ...state,
        user: action.payload,
      };

    /**
     * Logs the user out of the application
     */
    case AUTH_LOG_USER_OUT:
      return { ...initialState };
    default:
      return state;
  }
};
